var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',{staticClass:"gradient_clair",attrs:{"card":"","dense":""}},[_vm._v("\n  Prog "+_vm._s(_vm.number)+" : "+_vm._s(_vm.name)+"\n  "),_c('v-spacer'),_vm._v("\n  Pas : "+_vm._s(_vm.pas)+"\n  "),_c('v-spacer'),_vm._v("\n  Temps : "+_vm._s(_vm.totalHuman)+" / "+_vm._s(_vm.estimeHuman)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }